<template>
    <div class="sup-search-cont-comp">
        <div class="cont-list-box">
            <div class="item-box" v-for="(item, index) in curr_show_data_list" :key="index">
                <highlight-text
                    class="item-title"
                    :originalText="`${index + 1}、${item.title}`"
                    :highlightWords="search_highlight_words"
                    :highColor="$globalObj.color.__color_main_text_brand" @click="detail_click(item)"></highlight-text>
                <div class="item-breadcrumb-box" v-if="elbreadcrumb_list_computed.length > 0">
                    <el-breadcrumb separator-icon="ArrowRight">
                        <el-breadcrumb-item
                            v-for="(item_elbreadcrumb, index_elbreadcrumb) in elbreadcrumb_list_computed(item)"
                            :key="index_elbreadcrumb"
                            :title="item_elbreadcrumb.pathNodeName">
                            {{ item_elbreadcrumb.pathNodeName }}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="item-cont-box">
                    <highlight-text
                        class="cont-text"
                        :originalText="item.contentText"
                        :highlightWords="search_highlight_words"
                        :highColor="$globalObj.color.__color_main_text_brand"></highlight-text>
                    <el-icon @click="detail_click(item)">
                        <ArrowRightBold />
                    </el-icon>
                </div>
            </div>
        </div>
        <div class="page-box">
            <el-pagination
                @size-change="elpagination_size_change"
                @current-change="elpagination_current_change"
                :current-page="elpagination_curr_page"
                :page-size="elpagination_curr_page_size"
                :page-sizes="elpagination_page_sizes"
                :pager-count="5"
                :layout="elpagination_layout"
                :total="search_result_list.length">
            </el-pagination>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, watch, computed, getCurrentInstance } from 'vue';
import HighlightText from '../Common/HighlightText.vue';
import { useRouterStore } from '@/stores/router';
import { docSearchRead } from '@/service/interface';

const router_store = useRouterStore();
const { proxy } = getCurrentInstance();

const props = defineProps({
    tree_sel_type: Number,
    search_result_list: Array,
    search_highlight_words: Array,
});

const curr_show_data_list = ref([]); //当前显示列表
const elpagination_curr_page = ref(1);
const elpagination_page_sizes = ref([10, 20, 50, 100, 150, 200]);
const elpagination_curr_page_size = ref(10);
const elpagination_layout = ref('sizes, prev, pager, next, jumper');

const elbreadcrumb_list_computed = computed(() => {
    return function (item) {
        let path = [];
        if (item.path && item.path.length > 0) {
            path = item.path.slice(0, -1);
        }
        let typeName = '';
        for (let i = 0; i < proxy.$globalObj.search_tree_list.length; i++) {
            let e = proxy.$globalObj.search_tree_list[i];
            if (e.subCatalogs && e.subCatalogs.length > 0) {
                let findSubObj = e.subCatalogs.find((subItem) => subItem.id === item.docRecordType);
                if (findSubObj) {
                    typeName = findSubObj.name;
                    break;
                }
            }
            let mateId = item.docRecordType;
            if (
                item.docRecordType == proxy.$globalObj.group.platform ||
                item.docRecordType == proxy.$globalObj.group.plugin ||
                item.docRecordType == proxy.$globalObj.group.sdk
            ) {
                mateId = proxy.$globalObj.search_tree_obj.update_id;
            }
            if (e.id === mateId) {
                typeName = e.name;
                break;
            }
        }
        if (typeName.length) path.unshift({ pathNodeName: typeName });
        return path;
    };
});

watch(
    () => props.search_result_list,
    () => {
        service_handleData();
    }
);

onMounted(() => {
    service_handleData();
});

// // MARK Service 处理数据
const service_handleData = () => {
    curr_show_data_list.value = []; //重置
    const pages = [];
    for (let i = 0; i < props.search_result_list.length; i += elpagination_curr_page_size.value) {
        pages.push(props.search_result_list.slice(i, i + elpagination_curr_page_size.value));
    }
    if (elpagination_curr_page.value < 1 || elpagination_curr_page.value > pages.length) {
        return; // 无效的页码，不做任何操作
    }
    curr_show_data_list.value = pages[elpagination_curr_page.value - 1];
};

// MARK el-pagination  PageSize改变
const elpagination_size_change = (val) => {
    elpagination_curr_page_size.value = val;
    elpagination_curr_page.value = 1;
    service_handleData();
};
// MARK el-pagination  CurrentPage改变
const elpagination_current_change = (val) => {
    elpagination_curr_page.value = val;
    service_handleData();
};
// MARK Click  查看文档详情
const detail_click = (item) => {
    if (!item.path || item.path.length < 2) {
        proxy.$message.warning('文档不存在!');
        return;
    }
    let tree_obj = item.path[item.path.length - 2];
    let doc_obj = item.path[item.path.length - 1];
    if (
        item.docRecordType === proxy.$globalObj.group.sdk ||
        item.docRecordType === proxy.$globalObj.group.platform ||
        item.docRecordType === proxy.$globalObj.group.plugin
    ) {
        router_store.navigateToAnyDoc(item.docRecordType, {
            shareType: 1,
            treeId: tree_obj.id,
            docId: doc_obj.id,
            hlkeys: props.search_highlight_words,
        });
    } else {
        router_store.navigateToAnyDoc(item.docRecordType, { shareType: 1, treeId: tree_obj.id, docId: doc_obj.id });
    }
    docSearchRead(item.id);
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-search-cont-comp {
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    align-items: center;
    padding: 30px 48px 40px 40px;
    box-sizing: border-box;

    .cont-list-box {
        position: relative;
        width: 100%;
        height: 100%;
        margin-bottom: 10px;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        padding-right: 18px;
        box-sizing: border-box;

        .item-box {
            position: relative;
            margin-top: 40px;
            width: 100%;
            display: flex;
            flex-direction: column;

            &:nth-child(1) {
                margin-top: unset;
            }

            .item-title {
                position: relative;
                font-weight: 600;
                font-size: 22px;
                color: var(--color-main-text-primary);
                line-height: 27px;
                cursor: pointer;
            }

            .item-breadcrumb-box {
                position: relative;
                margin-top: 10px;
                width: 100%;
                height: 20px;

                :deep(.el-breadcrumb) {
                    width: 100%;
                    height: 100%;

                    .el-breadcrumb__item {
                        user-select: none;
                        display: flex;
                        align-items: center;

                        .el-breadcrumb__inner {
                            display: flex;
                            height: 100%;
                            color: var(--color-main-text-secondary);
                            font-size: 14px;
                            font-weight: 500;
                            line-height: 20px;
                        }

                        &:last-child .el-breadcrumb__inner {
                            color: var(--color-main-text-primary);
                        }
                    }
                }
            }

            .item-cont-box {
                position: relative;
                margin-top: 5px;
                width: 100%;
                display: flex;

                .cont-text {
                    position: relative;
                    width: 100%;
                    max-height: 70px;
                    font-weight: 300;
                    font-size: 14px;
                    color: var(--color-main-text-secondary);
                    line-height: 32px;
                    margin-right: 1em;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    /* 控制显示的行数 */
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    /* 当内容溢出时显示省略号 */
                }

                i {
                    position: absolute;
                    right: 0;
                    bottom: 8px;
                    font-size: 20px;
                    color: var(--color-main-text-disabled);
                    cursor: pointer;
                }
            }
        }
    }

    .page-box {
        position: relative;
        height: 30px;
        display: flex;
        flex-shrink: 0;
        align-items: center;

        .el-pagination {
            display: flex;
        }
    }
}
</style>
